import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode } from 'react';

export function ListItem({
  children,
  onClick,
  count,
}: {
  children: ReactNode;
  onClick: () => void;
  count: number;
}) {
  return (
    <div className="flex items-center w-full justify-between" onClick={onClick}>
      <div className="flex items-center gap-2">{children}</div>
      <div className="flex items-center gap-2">
        {count > 0 && (
          <span className="bg-primary-red-400 rounded-full size-4 text-neutrals-100 flex justify-center items-center text-xs">
            {count}
          </span>
        )}
        <FontAwesomeIcon icon={faChevronRight} />
      </div>
    </div>
  );
}
